import PageContainer from 'layouts/PageContainer'
import ManagementTable from './ManagementTable'

const ManagementPage = () => {
	return (
		<PageContainer>
			<ManagementTable />
		</PageContainer>
	)
}

export default ManagementPage
